<template>
	<div class="animated fadeIn">
		<b-row  id="pageinfo" class="pageinfo" style="padding: 10px 0 0 15px">
			<b-col cols="auto">
				<span class="haul-title">{{this.subTitle}}</span><br>
				<router-link v-if="haulId" :to="{ path: '/haul/' + data_in.id }">{{this.haulLink}} <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" x="0px" y="0px" viewBox="0 0 100 100" width="15" height="15" class="icon outbound"><path fill="currentColor" d="M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z"></path> <polygon fill="currentColor" points="45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9"></polygon></svg></router-link>
			</b-col>
			<b-col  style="margin-rght: 18px">
				<b-btn v-if="!edit" class="pull-right ml-1" variant="info" @click="closePopupHaul"><i class="fa fa-close"></i></b-btn>
				<b-button class="pull-right ml-1" v-show="(edit || edit_analyst)" @click="editHaul" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancel</b-button>
				<b-button class="pull-right" v-show="(edit || edit_analyst)" @click="updateHaul" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
				<b-dropdown class="pull-right ml-1" v-show="role =='super_admin' || role =='trucking_company_admin' || role =='analyst' || this.role =='marketing_accountant' || role =='trucking_operational_manager'" v-if="!edit && !edit_analyst" variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editHaul">Edit</b-dropdown-item>
					<b-dropdown-item v-if="(role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager') && !data_in.haul_invoice" @click="openModal" >Assign/Unassign Folder</b-dropdown-item>
					<b-dropdown-item v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" @click="deleteHaul" >Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</b-row>
		<b-row v-if="loadingData">
			<b-col cols="12" sm="12" md="12" lg="12">
				<p class="text-center">
					<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
				</p>
			</b-col>
		</b-row>
		<div v-else id='haul-information'>
			<b-row style="padding: 10px 0 0 15px">
				<b-col v-show="view1" sm="6" md="4" lg="4" xl="4">
					<b-form-group  label="Trucking Company" label-for="truck_company">
						<b-button class="p-0" v-show="!edit" @click="$router.push('/trucking_company/'+truck_company_id+'/')" size="sm" variant="link">{{truck_company}}</b-button>
						<b-form-select size="sm" v-show="edit" id="truck_company_id"  v-model="truck_company_id" :options="truck_company_select" @input="selects_trucking_company()" />
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Driver" label-for="full_name">
						<b-button class="p-0" v-show="!edit" @click="$router.push('/user/'+user_id+'/')" size="sm" variant="link">{{full_name}}</b-button>
						<b-form-select size="sm" v-show="edit" id="user_id" v-model="user_id" :options="driver_select" @input="selects_driver()" />
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group v-show="view" label="Energy Company" label-for="energy_company">
						<b-button class="p-0" v-show="!edit" @click="$router.push('/energy_company/'+energy_companies_id+'/')" size="sm" variant="link">{{this.energy_company}}</b-button>
						<b-form-select size="sm" v-show="edit" id="energy_companies_id" v-model="energy_companies_id" :options="energy_company_select" @input="selects_energy_company()" />
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Trailer 1" label-for="truck">
						<b-button class="p-0" v-show="!edit && view" @click="$router.push('/truck/'+truck_id+'/')" size="sm" variant="link">{{truck}}</b-button>
						<b-form-select size="sm" v-show="edit && view" id="truck_id" v-model="truck_id" :options="truck_select" />
						<b-form-input size="sm" v-show="!view" id="truck_id" plaintext v-model="truck_id" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Fluid Type" label-for="fluid_type">
						<b-button class="p-0" v-show="!edit" @click="$router.push('/fluid_type/'+fluid_type_id+'/')" size="sm" variant="link">{{fluid_type}}</b-button>
						<b-form-select size="sm" v-show="edit"  id="fluid_type_id"  v-model="fluid_type_id" :options="fluid_type_select" />
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Average Speed" label-for="avg_speed">
						<b-form-input plaintext id="avg_speed" v-model="avg_speed" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Truck Type" label-for="truck_type">
						<b-form-input id="truck_type" plaintext v-model="truck_type" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Truck Ticket #" label-for="ticket1">
						<b-form-input v-show="!edit" id="ticket1" plaintext v-model="ticket" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit" id="ticket1" v-model="ticket" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Load Location" label-for="load_location">
						<b-button class="p-0" v-show="!edit && !edit_analyst" @click="$router.push('/location/'+load_location_id+'/')" size="sm" variant="link">{{load_location}}</b-button>
						<b-form-select size="sm" v-show="edit" :disabled="load_location_select.length==0" id="load_location_id" v-model="load_location_id" :options="load_location_select" @input="selects_load_location()" />
						<b-form-select v-show="edit_analyst" :disabled="load_location_select.length==0" id="load_location_id" v-model="load_location_id" :options="load_location_select" @input="selects_load_location()" />
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Unload Location" label-for="unload_location">
						<b-button class="p-0" v-show="!edit && !edit_analyst" @click="$router.push('/location/'+unload_location_id+'/')" size="sm" variant="link">{{unload_location}}</b-button>
						<b-form-select size="sm" v-show="edit"  id="unload_location_id"  v-model="unload_location_id" :options="unload_location_select" />
						<b-form-select v-show="edit_analyst"  id="unload_location_id"  v-model="unload_location_id" :options="unload_location_select" />
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Terminal Ticket #" label-for="ticket"> 
						<b-form-input v-show="!edit" id="ticket" plaintext v-model="terminal_ticket" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit" id="ticket" v-model="terminal_ticket" type="text"></b-form-input>		
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Total Distance Km" label-for="total_distance">
						<b-form-input v-show="!edit" id="total_distance" plaintext v-model="total_distance" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit" id="total_distance" v-model="total_distance" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Gross Revenue" label-for="gross_revenue">
						<b-form-input plaintext id="gross_revenue" v-model="gross_revenue" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Net Revenue" label-for="netback">
						<b-form-input plaintext id="netback" v-model="netback" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Re-Routed" label-for="rerouted">
						<b-form-input plaintext id="rerouted" v-model="rerouted" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Terminal Boss" label-for="terminal_boss">
						<b-form-input v-show="!edit" plaintext id="terminal_boss" v-model="terminal_boss" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit" id="terminal_boss" v-model="terminal_boss" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Truck Unit" label-for="truck_unit">
						<b-button class="p-0" v-if="trucks_unit_id!==null" v-show="!edit" @click="$router.push('/trucks_unit/'+trucks_unit_id+'/')" size="sm" variant="link">{{truck_unit}}</b-button>
						<b-form-select size="sm" v-if="edit" id="truck_unit" v-model="trucks_unit_id" value-field="id" text-field="truck_unit" :options="truck_unit_select" />
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="ID" label-for="Id">
						<b-form-input plaintext id="Id" type="text"  v-model="data_in.id"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Created at" label-for="created_date">
						<b-form-input plaintext id="created_date" v-model="created_date" type="text"></b-form-input>
						<b-form-input plaintext id="created_time" v-model="created_time" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Updated at" label-for="updated_date">
						<b-form-input plaintext id="updated_date" v-model="updated_date" type="text"></b-form-input>
						<b-form-input plaintext id="updated_time" v-model="updated_time" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Trailer 2" label-for="truck2">
						<b-button class="p-0" v-show="truck2_id!==null && !edit && view" @click="$router.push('/truck/'+truck2_id+'/')" size="sm" variant="link">{{truck2}}</b-button>
						<b-form-select v-show="edit && view" id="truck2" v-model="truck2_id" :options="truck_select" />
						<b-form-input v-show="truck2_id!==null && !view" id="truck2" plaintext v-model="truck2_id" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group id="L2" label="Residue Last Contained" label-for="residue_last_contained">
						<b-form-checkbox 
							v-if="!edit"
							name="Checkboxes2" 
							plain 
							v-model="residue_last_contained"
							disabled>
						</b-form-checkbox>
						<b-form-checkbox 
							v-else
							name="Checkboxes2" 
							plain 
							v-model="residue_last_contained"
							value=true 
							unchecked-value=false>
						</b-form-checkbox>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="TDG" label-for="tdg">
						<b-button class="p-0" v-if="tdg_id!==null" v-show="!edit" @click="$router.push('/tdg/'+tdg_id+'/')" size="sm" variant="link">{{tdg}}</b-button>
						<b-form-select size="sm" v-if="edit" id="tdg" v-model="tdg_id" value-field="id" text-field="name" :options="tdg_select" />
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px;">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<span class="col-form-label">Flags</span>
				</b-col>
			</b-row>
			<div style="color:#3F3F46; height: 30px; margin: auto; padding: 10px 0 0 15px; font-size: 11px" v-for="message in messages">
				{{message}}
			</div>
			<b-row style="padding: 10px 0 0 15px;" v-if="multiload_data.length">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<span class="col-form-label">Loads</span>
				</b-col>
			</b-row>
			<div :style="'color:#3F3F46; margin: auto; padding: 10px 0 0px 15px; font-size: 11px; border-bottom: dashed 1px; background-color: ' + (index % 2 == 0 ? '#f8fbf8' : '#f5f5f5')" v-for="(load, index) in multiload_data" :key="index">
				<b-row class="mb-2" style="padding: 10px 0 0px 0px;">
					<b-col sm="6" md="4" lg="4" xl="4">
						<b-form-group label="Load Location" label-for="load_index">
							<b-form-input  size="sm" plaintext  :value="load.load_location" type="text"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col sm="6" md="4" lg="4" xl="4">
						<b-form-group label="Fluid type" label-for="fluid_index">
							<b-form-input  size="sm" plaintext  :value="load.fluid_type" type="text"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col sm="6" md="4" lg="4" xl="4">
						<b-form-group label="Volume estimate" label-for="volume_index">
							<b-form-input  size="sm" plaintext  :value="load.volume_estimate" type="text"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row class="mb-2" style="padding: 10px 0 0px 0px;">
					<b-col sm="6" md="4" lg="4" xl="4">
						<b-form-group label="Start" label-for="start_index">
							<b-form-input  size="sm" plaintext  :value="load.load_start_datetime" type="text"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col sm="6" md="4" lg="4" xl="4">
						<b-form-group label="Truck ticket" label-for="ticket_index">
							<b-form-input  size="sm" plaintext  :value="load.truck_ticket" type="text"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col sm="6" md="4" lg="4" xl="4">
						<b-form-group label="Comment" label-for="comment_index">
							<b-form-input  size="sm" plaintext  :value="load.comment" type="text"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
			</div>
			<b-row style="padding: 10px 0 0 15px;">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<span class="col-form-label">Volumes</span>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Volume Estimate" label-for="volume_estimate">
						<b-form-input v-show="!edit" plaintext id="volume_estimate" v-model="volume_estimate" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit" id="volume_estimate" v-model="volume_estimate" @keydown.native=volumeEstimateNumber($event) @blur.native="inputBlur('volume_estimate')" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Volume Total Actual" label-for="volume_actual">
						<b-form-input  v-show="!edit && !edit_analyst" plaintext id="volume_actual" v-model="volume_actual" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit"  id="volume_actual" v-model="volume_actual" @keydown.native=volumeActualNumber($event) @blur.native="inputBlur('volume_actual')" type="text"></b-form-input>
						<b-form-input v-show="edit_analyst"  id="volume_actual" v-model="volume_actual" @keydown.native=volumeActualNumber($event) @blur.native="inputBlur('volume_actual')" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Oil Actual" label-for="oil_actual">
						<b-form-input  v-if="!edit_analyst" id="oil_actual" plaintext v-model="oil_actual" type="text"></b-form-input>
						<b-form-input  v-else id="oil_actual" v-model="oil_actual" @keydown.native=oilActualNumber($event) @blur.native="inputBlur('oil_actual')" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Water Actual" label-for="water_actual">
						<b-form-input  id="water_actual" plaintext v-model="water_actual" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Water Cut Actual %" label-for="water_percentage_actual">
						<b-form-input v-show="!edit" plaintext id="water_percentage_actual" v-model="water_percentage_actual" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit" id="water_percentage_actual" v-model="water_percentage_actual" @keydown.native=waterActualNumber($event) @blur.native="inputBlur('water_percentage_actual')" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="BS%W Actual" label-for="bsw">
						<b-form-input v-if="!edit_analyst" plaintext id="bsw" v-model="bsw" type="text"></b-form-input>
						<b-form-input v-else id="bsw" v-model="bsw" @keydown.native=bswNumber($event) @blur.native="inputBlur('bsw')" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px;">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<span class="col-form-label">Times</span>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Start Date/Time" label-for="haul_start_date">
						<b-form-input v-show="!edit" id="haul_start_date" plaintext v-model="haul_start_date" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit"  id="haul_start_datetime" v-model="haul_start_datetime" type="date"></b-form-input>
						<b-form-input v-show="!edit" id="haul_start_time" plaintext v-model="haul_start_time" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit"  id="haul_start_time" v-mask="'##:##'" v-model="haul_start_time" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="End Date/Time" label-for="haul_start_date">
						<b-form-input v-show="!edit" id="haul_end_date" plaintext v-model="haul_end_date" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit" id="haul_end_datetime" v-model="haul_end_datetime" type="date"></b-form-input>
						<b-form-input v-show="!edit" id="haul_end_time" plaintext v-model="haul_end_time" type="text"></b-form-input>
						<b-form-input size="sm" v-show="edit" id="haul_end_time" v-mask="'##:##'" v-model="haul_end_time" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Drive Time" label-for="driving_time">
						<b-form-input plaintext id="driving_time" v-model="driving_time" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Stand by Time" label-for="stb">
						<b-form-input plaintext id="stb" v-model="stb" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Chain Up Time" label-for="Chain_Up_Time">
						<b-form-input plaintext id="Chain_Up_Time" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Total Personal Time" label-for="personal_time">
						<b-form-input plaintext id="personal_time" v-model="personal_time" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col v-for="(wait_time, index) in wait_times" :key="wait_time.id" sm="6" md="4" lg="4" xl="4">
					<b-form-group :label="wait_time.type_wait_times" :label-for="wait_time.type_wait_times">
						<b-form-input size="sm" v-show="edit" placeholder="hh:mm" v-mask="'##:##'" v-model="wait_time.total"  type="text"></b-form-input>
						<b-form-input v-show="!edit" plaintext v-mask="'##:##'" v-model="wait_time.total" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col v-show="personal_time_add" sm="6" md="4" lg="4" xl="4">
					<b-button class="p-0" @click="personal_time_option" size="sm" variant="link">Add Personal Time</b-button>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col v-for="(wait_time, index) in wait_times" v-if="wait_time.comments != '' && !edit" :key="wait_time.id" sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Comments Wait Time" label-for="Comments_Wait_Time">
						<b-form-textarea v-show="!edit" plaintext v-model="wait_time.comments" type="text" :rows="2" :max-rows="2"></b-form-textarea>
					</b-form-group>
				</b-col>
				<b-col v-for="(wait_time, index) in wait_times" v-if="edit" :key="wait_time.id" sm="6" md="4" lg="4" xl="4">
					<b-form-group :label="'Comments ' + wait_time.type_wait_times" label-for="Comments_Wait_Time">
						<b-form-input size="sm" v-show="edit" placeholder="Comments Wait Time" v-model="wait_time.comments" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Comments Start" label-for="comments_start">
						<b-form-textarea v-show="!edit" plaintext id="comments_start" v-model="comments_start" type="text" :rows="2" :max-rows="2"></b-form-textarea>
						<b-form-input size="sm" v-show="edit" id="comments_start" v-model="comments_start" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Comments End" label-for="comments_end">
						<b-form-textarea v-show="!edit" plaintext id="comments_end" v-model="comments_end" type="text" :rows="2" :max-rows="2"></b-form-textarea>
						<b-form-input size="sm" v-show="edit" id="comments_end" v-model="comments_end" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px;">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<span class="col-form-label">Haul Cost</span>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Regular Cost" label-for="regular_cost">
						<b-form-input plaintext id="regular_cost" v-model="cost_regular" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Stb Cost" label-for="stb_cost">
						<b-form-input plaintext id="stb_cost" v-model="cost_stb" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Worktime Cost" label-for="w_cost">
						<b-form-input plaintext id="w_cost" v-model="cost_worktime" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Unit Cost" label-for="unit_cost">
						<b-form-input plaintext id="unit_cost" v-model="unit_cost" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Drive Rate" label-for="rate">
						<b-form-input plaintext id="rate" v-model="rate" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col onmouseover="this.style.cursor='pointer'" v-on:click="est_detail()" sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Total Cost" label-for="total_cost">
						<b-form-input plaintext id="total_cost" v-model="total_cost" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Stand by Rate" label-for="stb_rate">
						<b-form-input plaintext id="stb_rate" v-model="stb_rate" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Chain Up Rate" label-for="chain_up_rate">
						<b-form-input plaintext id="chain_up_rate" v-model="chain_up_rate" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Chain Up Rate Applied" label-for="id_5" >								
						<b-form-checkbox 
							id="id_5"
            				v-model="chain_up_applied" 
							plain disabled
          				></b-form-checkbox>							
					</b-form-group>
				</b-col>

			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Agreement" label-for="agreement">
						<b-button v-if="agreement_id != 'No Assigned' && !edit" class="p-0" v-show="!edit" @click="$router.push('/agreement/'+agreement_id+'/')" size="sm" variant="link">{{this.agreement_id}}</b-button>					
						<b-form-input v-else plaintext id="agreement" v-model="agreement_id" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row v-show="data_in.haul_invoice" style="padding: 10px 0 0 15px;">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<b-button class="p-0" @click="invoiced_cost_click" size="sm" variant="link">Adjust Haul Cost</b-button>
					<b-button v-if="edit_invoiced_cost" class="p-0" @click="invoiced_cost_update" size="sm" variant="link">Update</b-button>
					<b-button v-if="edit_invoiced_cost" class="p-0" @click="invoiced_cost_cancel" size="sm" variant="link">Cancel</b-button>
				</b-col>
			</b-row>
			<b-row v-show="data_in.haul_invoice" style="padding: 10px 0 0 15px;">
				<b-col  sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Invoiced Cost" label-for="ic">
						<span v-if="!edit_invoiced_cost">{{'$'+this.invoiced_cost}}</span>					
						<b-form-input  v-else id="ic" v-model="invoiced_cost_text" @keydown.native=invoicedcostNumber($event) @blur.native="inputBlur('invoiced_cost_text')" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col  sm="8" md="6" lg="6" xl="6">
				    <b-form-group label="Justification" label-for="desc">
                        <b-form-textarea v-if="!edit_invoiced_cost" class="plaintext-input" plaintext id="desc" v-model="justification"  type="text" rows="3" max-rows="8"></b-form-textarea>
                        <b-form-textarea v-else id="desc" v-model="justification_text"  type="text" rows="3" max-rows="8"></b-form-textarea>
                    </b-form-group>
				</b-col>
			</b-row>

			<b-row style="padding: 10px 0 0 15px;">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<span class="col-form-label">Terminal Cost</span>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Terminal Treatment Fee" label-for="terminal_treatment_fee">
						<b-form-input plaintext id="terminal_treatment_fee" v-model="terminal_treatment_fee" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Terminal Other Fees" label-for="terminal_other_fees">
						<b-form-input plaintext id="terminal_other_fees" v-model="terminal_other_fees" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Terminal H2S Fees" label-for="terminal_h2s_fees">
						<b-form-input plaintext id="terminal_h2s_fees" v-model="terminal_h2s_fees" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Terminal Density Fees" label-for="terminal_density_fee">
						<b-form-input plaintext id="terminal_density_fee" v-model="terminal_density_fee" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
					<b-form-group label="Total Terminal Cost" label-for="total_terminal_treatment_fees">
						<b-form-input plaintext id="total_terminal_treatment_fees" v-model="total_terminal_treatment_fees" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px;">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<span class="col-form-label">Route Map</span>
				</b-col>
			</b-row>
			<b-row style="padding: 10px 0 0 15px;">
				<gmap-map v-bind:center="center" v-bind:zoom="zoom" v-bind:mapStyle="mapStyle" :mapTypeId="mapTypeId" style="width: 100%; height:500px">
					<gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
						<b-link :href="infoLink" target="_blank">{{infoContent}}</b-link>
					</gmap-info-window>
					<gmap-polyline v-bind:path.sync="path" v-bind:options="options">
					</gmap-polyline>
					<gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :label="m.label" :title="m.title" :icon="m.icon" :clickable="true" :draggable="m.draggable" @click="toggleInfoWindow(m, index)"></gmap-marker>
				</gmap-map>
			</b-row>
			<b-row style="padding: 10px 0 0 15px;">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<span class="col-form-label">Pictures</span>
				</b-col>
			</b-row>
			<b-row v-if="files !=''" style="padding: 10px 0 0 15px;">
				<div v-for="file in files" style="padding-bottom: 20px" :key="file.file">
					<p style="padding: 10px 0 0 15px;">{{file.comment}}</p>
					<img class="img-fluid rounded d-block m-l-none" v-bind:src="file.file" />
					<br>
					<b-btn size="sm" variant="primary" @click="saveImage(file.file)" class="float-right" style="margin-right: 30px">Download</b-btn>
					<br>
				</div>
			</b-row>
			<b-row v-else style="padding: 10px 0 0 15px;">
				<div style="padding-bottom: 20px">
					<p style="padding: 10px 0 0 15px;">No pictures available for this Haul</p>
				</div>
			</b-row>
			<b-row style="padding: 10px 0 0 15px;">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<span class="col-form-label">Hazard Assessment</span>
				</b-col>
			</b-row>
			<b-row style="padding: 5px 0 0 5px">
				<b-col sm="12" md="12" lg="12" xl="12">
					<span>Load Location: {{ load_location}}</span>
				</b-col>
			</b-row>

			<b-row  v-if="!edit" style="padding: 15px 0 0 15px">
				<b-col v-if="hz_load.hazards.length>0" sm="12" md="12" lg="12" xl="12">
					<b-form-group  :label-cols="1" id="L5" label="Hazards:" label-for="hzID" verticall>
							<b-form-checkbox-group text-field="hazard_name" class="custom-checkboxes" :options="hz_load.hazards" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
					</b-form-group>					
				</b-col>
				<b-col v-else sm="12" md="12" lg="12" xl="12">
					<p >No Hazards have been added</p>
				</b-col>
			</b-row>

			<b-row  v-else style="padding: 15px 0 0 15px">
				<b-col v-if="hazards.length>0" sm="12" md="12" lg="12" xl="12">
					<b-form-group  :label-cols="1" id="L6" label="Hazards:" label-for="hzID" vertical>
						<b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="hazards" name="Checkboxes2" plain v-model="hazard_id"  @input="HZChange"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="hzAllSelected" :indeterminate="indeterminateHZ" aria-describedby="" aria-controls="" plain @change="HZToggleAll">
							{{ hzAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>						
				</b-col>
				<b-col v-else sm="12" md="12" lg="12" xl="12">
					<p >No Hazards have been added</p>
				</b-col>
			</b-row>

			<b-row  v-if="!edit" style="padding: 15px 0 0 15px">
				<b-col v-if="hz_load.controls.length>0" sm="12" md="12" lg="12" xl="12">
					<b-form-group  :label-cols="1" id="L5" label="Controls:" label-for="ctlID" vertical>
							<b-form-checkbox-group text-field="control_name" class="custom-checkboxes" :options="hz_load.controls" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
					</b-form-group>					
				</b-col>
				<b-col v-else sm="12" md="12" lg="12" xl="12">
					<p >No controls have been added</p>
				</b-col>
			</b-row>

			<b-row  v-else style="padding: 15px 0 0 15px">
				<b-col v-if="controls.length>0" sm="12" md="12" lg="12" xl="12">
					<b-form-group  :label-cols="1" id="L6" label="Controls:" label-for="ctlID" vertical>
						<b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="controls" name="Checkboxes2" plain v-model="control_id"  @input="CTLChange"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="ctlAllSelected" :indeterminate="indeterminateCTL" aria-describedby="" aria-controls="" plain @change="CTLToggleAll">
							{{ ctlAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>						
				</b-col>
				<b-col v-else sm="12" md="12" lg="12" xl="12">
					<p >No controls have been added</p>
				</b-col>
			</b-row>

			<b-row style="padding: 5px 0 0 5px">
				<b-col sm="12" md="12" lg="12" xl="12">
					<span>Unload Location: {{ unload_location}}</span>
				</b-col>
			</b-row>

			<b-row  v-if="!edit" style="padding: 15px 0 0 15px">
				<b-col v-if="hz_unload.hazards.length>0" sm="12" md="12" lg="12" xl="12">
					<b-form-group  :label-cols="1" id="L5" label="Hazards:" label-for="hzID" vertical>
							<b-form-checkbox-group text-field="hazard_name" class="custom-checkboxes" :options="hz_unload.hazards" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
					</b-form-group>					
				</b-col>
				<b-col v-else sm="12" md="12" lg="12" xl="12">
					<p >No Hazards have been added</p>
				</b-col>
			</b-row>

			<b-row  v-else style="padding: 15px 0 0 15px">
				<b-col v-if="hazards.length>0" sm="12" md="12" lg="12" xl="12">
					<b-form-group  :label-cols="1" id="L6" label="Hazards:" label-for="hzID" vertical>
						<b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="hazards" name="Checkboxes2" plain v-model="hazard1_id"  @input="HZ1Change"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="hz1AllSelected" :indeterminate="indeterminateHZ1" aria-describedby="" aria-controls="" plain @change="HZ1ToggleAll">
							{{ hz1AllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>						
				</b-col>
				<b-col v-else sm="12" md="12" lg="12" xl="12">
					<p >No Hazards have been added</p>
				</b-col>
			</b-row>

			<b-row  v-if="!edit" style="padding: 15px 0 0 15px">
				<b-col v-if="hz_unload.controls.length>0" sm="12" md="12" lg="12" xl="12">
					<b-form-group  :label-cols="1" id="L5" label="Controls:" label-for="ctlID" vertical>
							<b-form-checkbox-group text-field="control_name" class="custom-checkboxes" :options="hz_unload.controls" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
					</b-form-group>					
				</b-col>
				<b-col v-else sm="12" md="12" lg="12" xl="12">
					<p >No controls have been added</p>
				</b-col>
			</b-row>

			<b-row  v-else style="padding: 15px 0 0 15px">
				<b-col v-if="controls.length>0" sm="12" md="12" lg="12" xl="12">
					<b-form-group  :label-cols="1" id="L6" label="Controls:" label-for="ctlID" vertical>
						<b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="controls" name="Checkboxes2" plain v-model="control1_id"  @input="CTL1Change"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="ctl1AllSelected" :indeterminate="indeterminateCTL1" aria-describedby="" aria-controls="" plain @change="CTL1ToggleAll">
							{{ ctl1AllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>						
				</b-col>
				<b-col v-else sm="12" md="12" lg="12" xl="12">
					<p >No controls have been added</p>
				</b-col>
			</b-row>

			<b-row v-if="cnr && cnr_details.length>0" style="padding: 10px 0 0 15px;">
				<b-col sm="12" md="12" lg="12" xl="12" style=" background-color: #ebe5d0; padding-top: 5px; padding-bottom: 5px">
					<span class="col-form-label">CNR</span>
				</b-col>
			</b-row>

			<b-row v-if="cnr && cnr_details.length>0" style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Request Number" label-for="request_number">
										<b-form-input v-if="!edit" plaintext id="request_number" v-model="cnr_details[0].request_number" type="text"></b-form-input>
										<b-form-input v-else id="request_number" v-model="cnr_details[0].request_number" type="text"></b-form-input>
									</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Tank Number" label-for="tank_number">
										<b-form-input v-if="!edit" plaintext id="tank_number" v-model="cnr_details[0].tank_number" type="text"></b-form-input>
										<b-form-input v-else id="tank_number" v-mask="'####'" v-model="cnr_details[0].tank_number" type="text"></b-form-input>
									</b-form-group>
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Start Gauge" label-for="start_gauge">
										<b-form-input v-if="!edit" plaintext id="start_gauge" v-model="cnr_details[0].start_gauge" type="text"></b-form-input>
										<b-form-input v-else id="start_gauge" v-mask="'###'" v-model="cnr_details[0].start_gauge" type="text"></b-form-input>
									</b-form-group>
				</b-col>
			</b-row>

			<b-row v-if="cnr && cnr_details.length>0" style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Finish Gauge" label-for="finish_gauge">
										<b-form-input v-if="!edit" plaintext id="finish_gauge" v-model="cnr_details[0].finish_gauge" type="text"></b-form-input>
										<b-form-input v-else id="finish_gauge" v-mask="'###'" v-model="cnr_details[0].finish_gauge" type="text"></b-form-input>
									</b-form-group>									
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Start Time Load" label-for="start_time_load">
										<b-form-input v-show="!edit" plaintext id="start_time_load" v-model="cnr_details[0].start_time_load" type="text"></b-form-input>
										<b-form-input v-show="edit" id="start_time_load" v-model="cnr_details[0].start_time_load_date" type="date"></b-form-input>
										<b-form-input v-show="edit"  id="start_time_load" v-mask="'##:##'" v-model="cnr_details[0].start_time_load_time" type="text"></b-form-input>
									</b-form-group>								
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="End Time Load" label-for="end_time_load">
										<b-form-input v-show="!edit" plaintext id="end_time_load" v-model="cnr_details[0].end_time_load" type="text"></b-form-input>
										<b-form-input v-show="edit" id="end_time_load" v-model="cnr_details[0].end_time_load_date" type="date"></b-form-input>
										<b-form-input v-show="edit" id="end_time_load" v-mask="'##:##'" v-model="cnr_details[0].end_time_load_time" type="text"></b-form-input>
									</b-form-group>							
				</b-col>
			</b-row>

			<b-row v-if="cnr && cnr_details.length>0" style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Temperature Load" label-for="temperature_load">
										<b-form-input v-if="!edit" plaintext id="temperature_load" v-model="cnr_details[0].temperature_load" type="text"></b-form-input>
										<b-form-input v-else id="temperature_load" @keydown.native=temperatureLoad($event) @blur.native="inputBlur1('this.cnr_details[0].temperature_load')" v-model="cnr_details[0].temperature_load" type="text"></b-form-input>
									</b-form-group>									
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Temperature Unload" label-for="temperature_unload">
										<b-form-input v-if="!edit" plaintext id="temperature_unload" v-model="cnr_details[0].temperature_unload" type="text"></b-form-input>
										<b-form-input v-else id="temperature_unload" @keydown.native=temperatureULoad($event) @blur.native="inputBlur1('this.cnr_details[0].temperature_unload')" v-model="cnr_details[0].temperature_unload" type="text"></b-form-input>
									</b-form-group>								
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Gross Weight" label-for="gross_weight">
										<b-form-input v-if="!edit" plaintext id="gross_weight" v-model="cnr_details[0].gross_weight" type="text"></b-form-input>
										<b-form-input v-else id="gross_weight" @keydown.native=grossWeight($event) @blur.native="inputBlur1('this.cnr_details[0].gross_weight')" v-model="cnr_details[0].gross_weight" type="text"></b-form-input>
									</b-form-group>							
				</b-col>
			</b-row>

			<b-row v-if="cnr && cnr_details.length>0" style="padding: 10px 0 0 15px">
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Tare Weight" label-for="tare_weight">
										<b-form-input v-if="!edit" plaintext id="tare_weight" v-model="cnr_details[0].tare_weight" type="text"></b-form-input>
										<b-form-input v-else id="tare_weight" @keydown.native=tareWeight($event) @blur.native="inputBlur1('this.cnr_details[0].tare_weight')" v-model="cnr_details[0].tare_weight" type="text"></b-form-input>
									</b-form-group>									
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Scale In Time" label-for="scale_in_time">
										<b-form-input v-if="!edit" plaintext id="scale_in_time" v-model="cnr_details[0].scale_in_time" type="text"></b-form-input>
										<b-form-input v-else id="scale_in_time" v-mask="'####'" v-model="cnr_details[0].scale_in_time" type="text"></b-form-input>
									</b-form-group>								
				</b-col>
				<b-col sm="6" md="4" lg="4" xl="4">
									<b-form-group label="Scale Out Time" label-for="scale_out_time">
										<b-form-input v-if="!edit" plaintext id="scale_out_time" v-model="cnr_details[0].scale_out_time" type="text"></b-form-input>
										<b-form-input v-else id="scale_out_time" v-mask="'####'" v-model="cnr_details[0].scale_out_time" type="text"></b-form-input>
									</b-form-group>							
				</b-col>
			</b-row>
		</div>

		<!--    Modal Dialogs -->
		<b-modal title="Add Personal Time" v-model="personal_time_modal" centered hide-header-close no-close-on-backdrop no-close-on-esc>
			<b-row>
				<b-col cols="12">
					<b-form-group :label-cols="4" horizontal label="Personal Time" label-for="personal_time">
						<b-form-input id="personal_time" placeholder="hh:mm" v-mask="'##:##'" @blur.native="timeBlur('total')" v-model="personal_time_items.total" type="text"></b-form-input>
					</b-form-group>
					<b-form-group :label-cols="4" horizontal label="Comments" label-for="comments_pt">
              			<b-form-input id="comments_ps" v-model="personal_time_items.comments" type="text"></b-form-input>
            		</b-form-group>
				</b-col>
			</b-row>
			<div slot="modal-footer" class="w-100">
        		<b-btn  size="md" class="float-left" variant="secondary" @click="hidepersonaltime()" >Cancel</b-btn>
            	<b-btn  size="md" class="float-right" variant="primary"   @click="personal_time_save()">Save</b-btn>
      		</div>
		</b-modal>

		<!-- Show Formula-->
		<b-modal title="" v-model="calculate" centered ok-only>
      		<b-row>
				<p style="margin-left: 5px;margin-bottom: 0; line-height: 15px;">Formula: {{formula}}</p>
				<b-col md="12">      
					<b-form-group :label-cols="5" horizontal label="Drive Rate:" label-for="id_1" >
						<b-form-input class="plaintext-input" plaintext id="id_1" v-model="rate" type="text"></b-form-input>
					</b-form-group>
					<b-form-group v-if="type_rate=='Volume Actual'" :label-cols="5" horizontal label="Volume Actual:" label-for="id_2" >
						<b-form-input class="plaintext-input" plaintext id="id_2" v-model="volume_actual" type="text"></b-form-input>
					</b-form-group>
					<b-form-group v-else :label-cols="5" horizontal label="Drive Time:" label-for="id_2" >
						<b-form-input class="plaintext-input" plaintext id="id_2" v-model="driving_time" type="text"></b-form-input>
					</b-form-group>
					<b-form-group :label-cols="5" horizontal label="Stand by Rate:" label-for="id_3" >
						<b-form-input class="plaintext-input" plaintext id="id_3" v-model="stb_rate" type="text"></b-form-input>
					</b-form-group>
					<b-form-group v-if="type_stb_rate=='Standby Time'" :label-cols="5" horizontal label="Standby Time:" label-for="id_22" >
						<b-form-input class="plaintext-input" plaintext id="id_22" v-model="stb" type="text"></b-form-input>
					</b-form-group>
					<b-form-group :label-cols="5" horizontal label="Chain Up Rate:" label-for="id_4" >
						<b-form-input class="plaintext-input" plaintext id="id_4" v-model="chain_up_rate" type="text"></b-form-input>
					</b-form-group>
					<b-form-group :label-cols="5" horizontal label="Chain Up Rate Applied" label-for="id_5" >								
						<b-form-checkbox 
							id="checkbox"
							class="custom-checkboxes"
            				v-model="chain_up_applied" 
							plain disabled
          			></b-form-checkbox>							
					</b-form-group>
					<b-form-group :label-cols="5" horizontal label="Worktime Rate:" label-for="id_6" >
						<b-form-input class="plaintext-input" plaintext id="id_6" v-model="worktime_rate" type="text"></b-form-input>
					</b-form-group>
					<b-form-group v-if="type_worktime_rate=='Work Time'" :label-cols="5" horizontal label="WorkTime:" label-for="id_222" >
						<b-form-input class="plaintext-input" plaintext id="id_222" v-model="work_time" type="text"></b-form-input>
					</b-form-group>
					<b-form-group :label-cols="5" horizontal label="Total Terminal Cost:" label-for="id_7" >
						<b-form-input class="plaintext-input" plaintext id="id_7" v-model="total_terminal_treatment_fees" type="text"></b-form-input>
					</b-form-group>
				</b-col>
      		</b-row>
		</b-modal>
		<!-- End Show Formula -->

		<b-modal title="Add to Folders" v-model="modalFolders" ok-variant="primary" centered hide-header-close no-close-on-backdrop no-close-on-esc>
			<b-container class="bv-example-row">
				<b-row>
					<b-col md="12">
						<b-form-group  :label-cols="2" id="L4" label-for="folderID" horizontal>
							<b-form-checkbox-group class="custom-checkboxes" :options="folderOptions" name="Checkboxes" plain v-model="selected" ></b-form-checkbox-group>
						</b-form-group>
					</b-col>
				</b-row>
			</b-container>
			<div slot="modal-footer" class="w-100">
				<b-btn size="md" class="float-left" variant="secondary" @click="modalFolders=false">
					Cancel
				</b-btn>

				<b-btn size="md" class="float-right" variant="primary" @click="addHaulsFolder()">
					Save
				</b-btn>
			</div>
		</b-modal>
	</div>
</template>
<script>
	import haul_service from './haul_service'
	import vSelect from 'vue-select'
	import * as VueGoogleMaps from 'vue2-google-maps'
	import Vue from 'vue'

	Vue.use(VueGoogleMaps, {
		load: {
			key: 'AIzaSyATdAd4aao2C4a1osTnnfVVK_wiVsS2uzs'
		}
	})
	export default {
		name: 'HaulPopup',
		created: function() {
			this.getHaulData()
		},
		props: {
			data_in: {
				type	: Object,
				default	: () => {}	
			},

			//id: {
			//	type: Number,
			//	default: 0
			//},
		},
		components: {
			vSelect
		},
		updated: function() {
				let h = document.getElementById('pageinfo').offsetHeight + 70
				document.getElementById('haul-information').style['height'] = 'calc(100vh - ' + h + 'px)'		
		},
		data() {
			return {
				haulId: null,
				modalFolders: false,
				files: "",
				subTitle: "",
				wait_times: [],
				water_actual: 0,
				water_estimate: 0,
				oil_actual: 0,
				oil_estimate: 0,
				unload_location_select: [],
				fluid_type_select: [],
				truck_company_select: [],
				load_location_select: [],
				trucks_select: [],
				energy_company_select: [],
				user_id: '',
				selected_driver: [],
				full_name: '',
				driver_select: [],
				driver_select2: [],
				truck_select: [],
				mapTypeId: 'roadmap',
				zoom: 14,
				options: {
					strokeColor: '#e5c163',
					strokeOpacity: 1.0,
					strokeWeight: 6,
					geodesic: true,
				},
				center: {
					"lat": 0,
					"lng": 0
				},
				markers: [],
				path: [],
				infoContent: '',
				infoLink: '',
				infoWindowPos: {
					lat: 0,
					lng: 0
				},
				infoWinOpen: false,
				currentMidx: null,
				infoOptions: {
					pixelOffset: {
						width: 0,
						height: -35
					}
				},
				companyName: '',
				edit: false,
				editHaulModal: false,
				tabIndex:1,
				load_location: '',
				loadingData: true,
				unload_location: '',
				haul_start_date: '',
				waitCount: 0,
				trucks: [],
				driver: 0,
				areas: 0,
				areasCount: 50,
				originalData: null,
				originalData1: null,
				avg_speed: 0,
            	cost_regular: 0,
            	cost_stb: 0,
				total_cost: 0,
				role:'',
				view:true,
				view1:true,
				truck_type : '',
				selected: [],
				energy_companies_id : '',
				model: {
					id: null,
					initial_date: null,
					end_date: null,
					rate: null,
					charge_type: null,	
					cost_type: null,
					chain_up_rat: null,
					energy_company: null,
					trucking_company: null,
					truck_type: null,
				},
				modalAgreement: false,
				striped: false,
				bordered: true,
				borderless: false,
        		outlined: true,
        		small: true,
				hover: false,
				dark:false,
      			fixed: true,
				personal_time_add:true,
				personal_time_modal:false,
				personal_time_items: {
					total: '',
					comments: ''
				},
				mapStyle: null,
				terminal_treatment_fee: null,
    			terminal_other_fees: null,
    			terminal_h2s_fees: null,
    			terminal_density_fee: null,
				total_terminal_treatment_fees: null,
				gross_revenue:	null,
				netback: null,
				rerouted: null,
				agreement_id: null,
				calculate: false,
				chain_up_rate: '',
				chain_up_time: '',
				worktime_rate: '',
				rate: '',
				stb_rate					: '',
				volume_actual				: '',
				formula						: 'Total Cost: (Drive Rate * Volume Estimate) + (Stand by Rate * Volume Estimate) + (Worktime Rate * Volume Estimate) + Total Terminal Cost + Chain Up Rate',						
				type_rate					: 'Volume Estimate',	
        		type_stb_rate				: 'Volume Estimate',
				type_worktime_rate			: 'Volume Estimate',
				work_time					: '00:00',
				trucking_companies			: [],
				folder_haul					: [],
				folderOptions				: [],
				folders						: [],
				multiload_data				: [],
				chain_up_applied   			: false,
				edit_analyst				: false,
				//haul_invoice                : true,
				edit_invoiced_cost			: false,
				invoiced_cost				: '0.00',
				justification               : '',
				invoiced_cost_text  		: '',
				justification_text          : '',
				hz_load                     : {'hazards':[],'controls':[] },
				hz_unload                   : {'hazards':[],'controls':[] },
				hazards						: [],
				controls					: [],
				hazard_id					: [],
				control_id					: [],
				indeterminateHZ				: false,
				hzAllSelected				: false, 
				indeterminateCTL   			: false,
				ctlAllSelected				: false, 
				hazard1_id					: [],
				control1_id					: [],
				indeterminateHZ1			: false,
				hz1AllSelected				: false, 
				indeterminateCTL1  			: false,
				ctl1AllSelected				: false,   
				trucks_unit_id 				: null,
				truck_unit 					: '',
				terminal_boss				: '',
				truck_unit_select           : [],

				tdg_id						: null,
				tdg							: '',
				residue_last_contained		: 'false',
				cnr                         : false,
				truck2_id 					: null,
				truck2 						: '',
				tdg_select					: [],
				cnr_details					: [],
				driving_time                : '',
				cost_worktime 				: 0,
			}
		},
		computed: {
			haulLink () {
				return this.haulId ? location.protocol + '//' + location.host + '/#/haul/' + this.haulId : ''
			}
		},
		methods: {
			closePopupHaul () {
				document.body.classList.toggle('aside-menu-hidden', true)
				this.$root.$emit('closePopup')
				/* document.body.style['overflow']=''
				document.body.getElementsByClassName('container-fluid')[0].style['overflow'] = ''
      			document.body.getElementsByClassName('container-fluid')[0].style['height'] = '' */
			},
			personal_time_option(){
				this.personal_time_modal=true
			},
			hidepersonaltime(){
				this.personal_time_modal=false
			},
			getHaulData() {
				haul_service.getByv2(this.data_in.id)
				.then(data => {
					if (data.status == 'success') {
						this.loadingData = false
						this.originalData = data['haul']
						this.restoreOriginalData()
						this.messages = data['messages']
						this.haulId = this.data_in.id
						this.getHaulData1()
					}
					else {
						this.$swal(data.status, data.message, data.status)
						this.loadingData = false
						return
					}
				})
				.catch(error => {
					this.$swal('Error', 'Server not response.2 ' + error, 'error')
					this.loadingData = false
				})
			},
			getHaulData1() {
				haul_service.getByv22(this.data_in.id)
				.then(data => {
					if (data.status == 'success') {
						this.originalData1 	= data['haul']
						this.restoreOriginalData1()
						this.folder_haul = data.folder_haul
						this.folderHaulIds 	= this.folder_haul.map((item) => {
							return item.id
						})
						this.selected = this.folderHaulIds
						this.messages = data['messages']

						this.role = data['role']
						this.hazards = data.hazards
						this.controls = data.controls
						if (this.role =='super_admin') {
							this.view=true
							this.get_trucking_companies()
							this.getUnloadLocation (this.user_id)
							this.getLoadLocation (this.energy_companies_id,this.user_id)
						} 
						else if (this.role =='super_analyst') {
							this.view=false
						} 
						else if (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
							this.view1=false
							this.get_trucking_companies()
							this.getUnloadLocation (this.user_id)
							this.getLoadLocation (this.energy_companies_id,this.user_id)
						} else if (this.role =='analyst' || this.role =='marketing_accountant') {
							this.getUnloadLocation (this.user_id)
							this.getLoadLocation (this.energy_companies_id,this.user_id)
							this.view=false
						}
						this.subTitle = 'Haul ' + this.originalData1.times.haul_start_date + " - " + (new Date("1990-02-02 "+this.originalData1.times.haul_start_time)).toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true})
					}
					else {
						this.$swal(data.status, data.message, data.status)
						this.loadingData = false
						return
					}
				})
				.catch(error => {
					this.$swal('Error', 'Server not response. ' + error, 'error')
					this.loadingData = false
				})
			},
			restoreOriginalData1() {
				let features = this.originalData1
				this.path = features.map.path
				this.center = features.map.center
				this.markers = features.map.markers
				this.haul_start_date = features.times.haul_start_date
				this.haul_start_time = features.times.haul_start_time
				this.haul_end_date 	= features.times.haul_end_date
				this.haul_end_time = features.times.haul_end_time
				this.wait_times = JSON.parse(JSON.stringify(features.wait_times))
				if (this.wait_times.length>0){
					let add_personal_time = this.wait_times.map(o => o.type_id).indexOf(6)
					if (add_personal_time > -1) { 
						this.personal_time_add=false
					}
				}
				
				this.waitCount = features.wait_count
				this.driving_time = features.times.driving_time
				this.stb = features.times.stb
				this.personal_time = features.times.personal_time
				this.work_time = features.times.work_time
				this.files = features.files
			},
			restoreOriginalData() {
				let features = this.originalData

				this.user_id = features.user_id
				this.haulId = features.haul_id
				this.user = features.user
				this.full_name = features.full_name
				
				this.energy_companies_id = features.energy_companies_id
				this.energy_company = features.energy_company
				this.fluid_type_id = features.fluid_type_id
				this.fluid_type = features.fluid_type
				this.load_location_id = features.load_location_id
				this.load_location = features.load_location
				this.unload_location_id = features.unload_location_id
				this.unload_location = features.unload_location
				this.truck_id = features.truck_id
				this.truck = features.truck
				this.truck_type = features.truck_type
				this.truck_company = features.truck_company
				this.truck_company_id = features.truck_company_id

				this.volume_actual = features.volume_actual
				this.volume_estimate = features.volume_estimate
				this.bsw = features.bsw
				this.oil_actual = features.oil_actual
				this.water_actual = features.water_actual
				this.ticket = features.ticket
				this.terminal_ticket = features.terminal_ticket
				this.total_distance = features.total_distance
				this.comments_start = features.comments_start
				this.comments_end = features.comments_end
				this.other_comments = features.other_comments
				this.updated_date = features.updated_date
				this.updated_time = features.updated_time
				this.created_date = features.created_date
				this.created_time = features.created_time

				this.haul_start_datetime = features.haul_start_datetime
				this.haul_end_datetime 	= features.haul_end_datetime
				this.water_percentage_estimate = features.water_percentage_estimate
				this.water_percentage_actual = features.water_percentage_actual
				

				this.avg_speed = features.avg_speed

				this.rate = features.rate
				// this.chain_up_rate = features.chain_up_rate
				if (features.chain_up_rate!='N/A' ) {
					this.chain_up_rate 							= features.chain_up_rate
					this.chain_up_applied = true
				} else {
					this.chain_up_rate 		= "$0.00"
					this.chain_up_applied = false
				}
				this.chain_up_time = features.chain_up_time
				this.stb_rate = features.stb_rate
				this.worktime_rate = features.worktime_rate

				this.total_cost = features.total_cost
				this.formula = features.formula
				this.type_rate = features.type_rate
        		this.type_stb_rate = features.type_stb_rate
        		this.type_worktime_rate = features.type_worktime_rate
				
				this.terminal_treatment_fee = features.terminal_treatment_fee
				this.terminal_other_fees = features.terminal_other_fees
				this.terminal_h2s_fees = features.terminal_h2s_fees
				this.terminal_density_fee = features.terminal_density_fee
				this.total_terminal_treatment_fees = features.total_terminal_treatment_fees

				this.gross_revenue = features.gross_revenue
				this.netback = features.netback
				this.rerouted = features.rerouted
				this.agreement_id = features.agreement_id	

				this.unit_cost = features.unit_cost
				this.invoiced_cost = features.invoiced_cost
				this.justification = features.justification

				this.path = []
				this.center = {
					"lat": 0,
					"lng": 0
				}
				this.markers = []
				this.haul_start_date = ""
				this.haul_start_time = ""
				this.haul_end_date = ""
				this.haul_end_time = ""
				this.wait_times = []
				this.waitCount = ""
				this.driving_time = ""
				this.stb = ""
				this.personal_time = ""
				this.work_time = ""
				this.files = ""
				
				this.multiload_data = features.loads ? features.loads : []
				this.hz_load.hazards = features.hz_load.hazards
				this.hz_load.controls = features.hz_load.controls
				this.hz_unload.hazards = features.hz_unload.hazards
				this.hz_unload.controls = features.hz_unload.controls

				this.trucks_unit_id = features.trucks_unit_id
				this.truck_unit 	= features.truck_unit
				this.terminal_boss 	= features.terminal_boss

				this.truck2_id 						= features.truck2_id
				this.truck2 						= features.truck2
				this.tdg_id							= features.tdg_id
				this.tdg							= features.tdg
				this.residue_last_contained		    = features.residue_last_contained	
				this.cnr                            = features.cnr
				this.cnr_details					= features.cnr_details
				this.cost_regular = features.cost_regular
				this.cost_worktime = features.cost_worktime
				this.cost_stb = features.cost_stb
		
			},
			personal_time_save() {
				this.personal_time_modal=false
				if (this.personal_time_items.total!='') {
					let new_personal_time = {
					 	type_id: 6,
					 	total: this.personal_time_items.total,
					 	comments: this.personal_time_items.comments
					}
					haul_service.savePersonalTime(this.haulId, new_personal_time)
          			.then((data) => {
                		if (data[0] == 'success') {
							let new_personal_time_view = {
					 			id: data[2],
					 			type_id: 6,
					 			total: this.personal_time_items.total,
					 			type_wait_times: "Personal Time",
					 			comments: this.personal_time_items.comments
							}
							this.wait_times.push(new_personal_time_view)
							this.personal_time_add = false
							this.personal_time = this.personal_time_items.total
						} 
						else {
							this.personal_time_add=false
                    		Vue.swal(data[0], data[1], data[0])
                		}
          			})
          			.catch(error => {
						this.personal_time_add=false
            			Vue.swal('Error', 'Server not response. ' + error, 'error')
          			})
				}
			},
			timeBlur(variableName) {
        		let variableValue = this.personal_time_items[variableName]
        		if (variableValue.length == 0) {
          			this.personal_time_items[variableName] = "00:00"
				} 
				else {
          			let tempValue = variableValue.split(":")
          			if (tempValue.length == 1) {
            			let min = String(Math.min(tempValue[0], 24))
            			this.personal_time_items[variableName] = ("0" + min).slice(-2) + ":00"
					} 
					else if (tempValue.length == 2) {
            			let min1 = String(Math.min(tempValue[0], 24))
            			let min2 = String(Math.min(tempValue[1], 59))
            			this.personal_time_items[variableName] = ("0" + min1).slice(-2) + ":" + ("0" + min2).slice(-2)
          			}
        		}
			},
			saveImage(file) {
				var item_image = file.replace(/^data:image\/(png|jpg|gif);base64,/, "")
				let blob = this.base64toBlob(item_image, 'image/gif')
				const data = window.URL.createObjectURL(blob)
    			const link = document.createElement('a')
				link.href = data
  				link.download = 'photo.gif'
				document.body.appendChild(link);
    			link.click()
				setTimeout(() => {
					window.URL.revokeObjectURL(data)
				}, 2000)
			},
			base64toBlob(base64Data, contentType) {
    			contentType = contentType || '';
    			var sliceSize = 1024;
    			var byteCharacters = atob(base64Data);
				//var byteCharacters = base64Data
    			var bytesLength = byteCharacters.length;
    			var slicesCount = Math.ceil(bytesLength / sliceSize);
    			var byteArrays = new Array(slicesCount);

    			for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        			var begin = sliceIndex * sliceSize;
        			var end = Math.min(begin + sliceSize, bytesLength);

        			var bytes = new Array(end - begin);
        			for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            			bytes[i] = byteCharacters[offset].charCodeAt(0);
        			}
        			byteArrays[sliceIndex] = new Uint8Array(bytes);
    			}
    			return new Blob(byteArrays, { type: contentType });
			},
			deleteHaul(item) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Haul?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				})
				.then((result) => {
					if (result.value) {
						haul_service.delete(this.haulId)
						.then(data => {
							this.$swal(data[0], data[1], data[0])
							if (data[0] == 'success') {
								if (!this.data_in.haul_invoice) {
									this.$router.replace('/hauls')
									this.$root.$emit('haulUpdated')
									this.closePopupHaul()
								} else {
									if (this.data_in.edit.length===0) {
										this.$router.replace('/invoices_hauls')
										this.$root.$emit('haul_Updated')
										this.closePopupHaul()
									} else {
										this.$router.replace('/invoice/'+this.data_in.edit+'/')
										this.$root.$emit('haul_edit')
										this.closePopupHaul()
									}

								}
							}
						})
						.catch(error => {
							this.$swal('Error', 'Server not response. ' + error, 'error')
						})
					}
				})
				this.edit = false
			},
			editHaul() {
				if (this.edit || this.edit_analyst) {
					this.edit = false
					this.edit_analyst = false
				} else {	
						if (this.role==='super_admin' || this.role =='trucking_company_admin' || this.role =='trucking_operational_manager'){
								//this.get_trucking_companies()
								//this.getUnloadLocation (this.user_id)
								//this.getLoadLocation (this.energy_companies_id,this.user_id)
								this.edit = true
						} else if (this.role==='analyst' || this.role =='marketing_accountant') {
								this.edit_analyst = true
								//this.getUnloadLocation (this.user_id)
								//this.getLoadLocation (this.energy_companies_id,this.user_id)
						}
						this.setupFields()
				}
			},
			get_trucking_companies() {
				haul_service.get_trucking_companies(this.truck_company_id)
          		.then((data) => {
                	if (data.status  == 'success') {
						this.trucking_companies = data.trucking_companies
						let trucking_companies = this.trucking_companies
						this.truck_company_select = trucking_companies.map((item) => {
							return {
								'value': item.id,
								'text': item.name
							}
						})
						this.selects_trucking_company()
						this.selects_driver()
						this.select_truck_unit()
					} 
					else {
						this.$swal(data.status, data.message, data.status)
						this.trucking_companies = []
                	}
				})
				.catch(error => {
					this.$swal('Error', 'Server not response. ' + error, 'error')
					this.trucking_companies = []
				})
			},
			selects_trucking_company() {
				if (this.role =='super_admin') {
				let trucking_companies = this.trucking_companies

				let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.truck_company_id)
				if (current_truck_company_index > -1) {
					let drivers = trucking_companies[current_truck_company_index]['drivers']
					this.driver_select = drivers.map((item) => {
						return { 'value': item.id, 'text': item.name }
					})
					
					let trucks = trucking_companies[current_truck_company_index]['trucks']
					this.truck_select = trucks.map((item) => {
						return { 'value': item.id, 'text': item.truck_name }
					})
					// SAME as in APP - Select if there is only one item in the array
					if(this.driver_select.length == 1) {
						this.full_name = this.driver_select[0].text
						this.user_id = this.driver_select[0].value
					}
					if(this.truck_select.length == 1) {
						this.truck = this.truck_select[0].text
						this.truck_id = this.truck_select[0].value
					}
				}
				}
				if (this.role == 'trucking_company_admin' || this.role =='trucking_operational_manager') {
					let trucking_companies = this.trucking_companies
					this.truck_company_select = this.trucking_companies[0]['id']
					this.truck_company_id = this.trucking_companies[0]['id']

					let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.truck_company_id)
				
					let drivers = this.trucking_companies[0]['drivers']
					this.driver_select = drivers.map((item) => {
						return { 'value': item.id, 'text': item.name }
					})
					
					let trucks = this.trucking_companies[0]['trucks']
					this.truck_select = trucks.map((item) => {
						return { 'value': item.id, 'text': item.truck_name }
					})
					// SAME as in APP - Select if there is only one item in the array
					if(this.driver_select.length == 1) {
						this.full_name = this.driver_select[0].text
						this.user_id = this.driver_select[0].value
					}
					if(this.truck_select.length == 1) {
						this.truck = this.truck_select[0].text
						this.truck_id = this.truck_select[0].value
					}
				}
			},
			selects_driver() {
				if (this.role == 'trucking_company_admin' || this.role =='trucking_operational_manager') {
					let trucking_companies = this.trucking_companies
					this.truck_company_select = this.trucking_companies[0]['id']
					this.truck_company_id = this.trucking_companies[0]['id']
					let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.truck_company_id)
					if (current_truck_company_index > -1) {
						let drivers = this.trucking_companies[0]['drivers']
						let drivers_index = drivers.map(o => o.id).indexOf(this.user_id)
						if (drivers_index > -1) {
							let energycompanies =  drivers[drivers_index]['energy_companies']
							this.energy_company_select = energycompanies.map((item) => {
								return { 'value': item.id, 'text': item.company_name }
							})
						}
					}
				}
				if (this.role == 'super_admin') {
					let trucking_companies = this.trucking_companies
					let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.truck_company_id)
					if (current_truck_company_index > -1) {
						let drivers = trucking_companies[current_truck_company_index]['drivers']
						let drivers_index = drivers.map(o => o.id).indexOf(this.user_id)
						if (drivers_index > -1) {
							let energycompanies =  drivers[drivers_index]['energy_companies']
							this.energy_company_select = energycompanies.map((item) => {
								return { 'value': item.id, 'text': item.company_name }
							})
						}
					}
				}
			},
			getUnloadLocation (driver_id) {
				haul_service.getUnloadLocation(driver_id)
				.then(data => {
					if (data['status'] == 'success') {
						let loads_locations = data['unload_locations']
						this.unload_location_select = loads_locations.map((item) => {
							return {
								'value': item.id,
								'text': item.legal_location
							}
						})
					} 
					else {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					}
					this.loadingData = false
				})
				.catch(error => {
					this.$swal('Error', 'Server not response. ' + error, 'error')
					this.loadingData = false
				})
			},
			getLoadLocation (energy_company_id, driver_id) {

        		haul_service.getLoadLocation(energy_company_id,driver_id)
          		.then(data => {
                	if (data['status'] == 'success') {
						
						this.loads_locations = data['load_locations']
                   		this.load_location_select = this.loads_locations.map((item) => {
							return {
								'value': item.id,
								'text': item.legal_location
							}
                   		})
                   		if (this.load_location_select.length == 1) {
							this.load_location = this.load_location_select[0].text
							this.load_location_id = this.load_location_select[0].value
                     	}
						let loads_locations = this.loads_locations
						let loads_locations_index = loads_locations.map(o => o.id).indexOf(this.load_location_id)
						if (loads_locations_index > -1) {
						 	let fluid_types = loads_locations[loads_locations_index]['fluids']
						 	this.fluid_type_select = fluid_types.map((item) => {
								return {
									'value': item.id,
									'text': item.name
								}
						 	})
							this.tdg_select = []
							let ft_index = fluid_types.map(o => o.id).indexOf(this.fluid_type_id)
							if (ft_index > -1) {
								if ('tdg' in fluid_types[ft_index]) {
									this.tdg_select = fluid_types[ft_index].tdg
								} 
							} 
						}
					}
					else {
				  		this.$swal('Error', 'Server not response. ' + error, 'error')
                	}
                	this.loadingData = false
          		})
          		.catch(error => {
            		this.$swal('Error', 'Server not response. ' + error, 'error')
            		this.loadingData = false
          		})
			},
			setupFields(clear) {
				if (this.role == 'super_admin') {
					this.volume_actual = this.volume_actual.replace(/[^\./\d]/g, '')
					this.water_percentage_actual = this.water_percentage_actual.replace(/[^\./\d]/g, '')
					this.volume_estimate = this.volume_estimate.replace(/[^\./\d]/g, '')
					this.total_distance = this.total_distance.replace(/[^\./\d]/g, '')
					this.oil_actual    		= this.oil_actual.replace(/[^\./\d]/g, '')
					this.bsw 							= this.bsw.replace(/[^\./\d]/g, '')
				} 
				else if (this.role == 'trucking_company_admin' || this.role =='trucking_operational_manager') {
					this.volume_actual = this.volume_actual.replace(/[^\./\d]/g, '')
					this.water_percentage_actual = this.water_percentage_actual.replace(/[^\./\d]/g, '')
					this.volume_estimate = this.volume_estimate.replace(/[^\./\d]/g, '')
					this.total_distance = this.total_distance.replace(/[^\./\d]/g, '')
					this.oil_actual    		= this.oil_actual.replace(/[^\./\d]/g, '')
					this.bsw 							= this.bsw.replace(/[^\./\d]/g, '')
				} else if (this.role =='analyst' || this.role =='marketing_accountant') {
					this.volume_actual   	= this.volume_actual.replace(/[^\./\d]/g, '')
					this.water_percentage_actual    = this.water_percentage_actual.replace(/[^\./\d]/g, '')
					this.volume_estimate = this.volume_estimate.replace(/[^\./\d]/g, '')
					this.total_distance  = this.total_distance.replace(/[^\./\d]/g, '')
					this.oil_actual    		= this.oil_actual.replace(/[^\./\d]/g, '')
					this.bsw 							= this.bsw.replace(/[^\./\d]/g, '')
				}


				let hazard = this.hz_load.hazards 
				if (hazard.length>0) {
					this.hazard_id 	= 	hazard.map((item) => {
										return item.hazard_id
									})
				} else {
					this.hazard_id 	= []

				}

				let hazard1 = this.hz_unload.hazards 
				if (hazard1.length>0) {
					this.hazard1_id 	= 	hazard1.map((item) => {
										return item.hazard_id
									})
				} else {
					this.hazard1_id 	= []

				}

				let control = this.hz_load.controls 
				if (control.length>0) {
					this.control_id 	= 	control.map((item) => {
										return item.control_id
									})
				} else {
					this.control_id 	= []

				}

				let control1 = this.hz_unload.controls 
				if (control1.length>0) {
					this.control1_id 	= 	control1.map((item) => {
										return item.control_id
									})
				} else {
					this.control1_id 	= []
				}
			},
			updateHaul() {
				if(!this.okToUpdate()) {
					return
				}
				this.haulUpdate = {
					'energy_companies_id'      : this.energy_companies_id,
					'fluid_type_id'            : this.fluid_type_id,
					'load_location_id'         : this.load_location_id,
					'unload_location_id'       : this.unload_location_id,
					'truck_id'                 : this.truck_id,
					'user_id'                  : this.user_id,
					'haul_start_datetime'      : this.haul_start_datetime,
					'haul_end_datetime'        : this.haul_end_datetime,
					'haul_start_date'          : this.haul_start_date,
					'haul_start_time'          : this.haul_start_time,
					'haul_end_date'            : this.haul_end_date,
					'haul_end_time'            : this.haul_end_time,
					'volume_estimate'          : this.volume_estimate,
					'volume_actual'            : this.volume_actual,
					'oil_actual'               : this.oil_actual,
					'water_percentage_estimate': this.water_percentage_estimate,
					'water_percentage_actual'  : this.water_percentage_actual,
					'bsw'                      : this.bsw,
					'truck_ticket'             : this.ticket,
					'terminal_ticket'          : this.terminal_ticket,
					'total_distance'           : this.total_distance,
					'comments_start'           : this.comments_start,
					'other_comments'           : this.other_comments,
					'comments_end'             : this.comments_end,
					"wait_times" 			   : [...this.wait_times],
					"hazard_id"				   : this.hazard_id,
					"control_id"			   : this.control_id,
					"hazard1_id"			   : this.hazard1_id,
					"control1_id"			   : this.control1_id,
					"terminal_boss"			   : this.terminal_boss,
					"trucks_unit_id"		   : this.trucks_unit_id,
					"truck2_id" 			   : this.truck2_id,
				    "tdg_id"				   : this.tdg_id,
				    "residue_last_contained"   : this.residue_last_contained,
					"cnr"                      : this.cnr,
					"cnr_details"				: this.cnr_details

				}
				haul_service.update(this.haulUpdate, this.haulId)
				.then((data) => {
					this.$swal(data[0], data[1], data[0])
					.then((result) => {
						this.getHaulData()
					})
					if (!this.data_in.haul_invoice) {
						this.$root.$emit('haulUpdated')
					} else {
						this.$root.$emit('haul_Updated')
					}
				})
				.catch(error => {
					this.$swal('Error', 'Server not response. ' + error, 'error')
				})
				this.edit = false
				this.edit_analyst = false
			},
			okToUpdate() {
				if(this.energy_companies_id === undefined || this.energy_companies_id.length == 0) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning')
					return false
				} else if(this.fluid_type_id === undefined || this.fluid_type_id.length == 0) {
					this.$swal('Alert!', 'Fluid Type not selected', 'warning')
					return false
				} else if(this.load_location_id === undefined || this.load_location_id.length == 0) {
					this.$swal('Alert!', 'Load Location not selected', 'warning')
					return false
				} else if(this.truck_company_id === undefined || this.truck_company_id.length == 0) {
					this.$swal('Alert!', 'Truck Company not selected', 'warning')
					return false
				} else if(this.unload_location_id === undefined || this.unload_location_id.length == 0) {
					this.$swal('Alert!', 'Unload Location not selected', 'warning')
					return false
				} else if(this.user_id === undefined || this.user_id.length == 0) {
					this.$swal('Alert!', 'Driver not selected', 'warning')
					return false
				} else if(this.truck_id === undefined || this.truck_id.length == 0) {
					this.$swal('Alert!', 'Truck not selected', 'warning')
					return false
				} else if (this.volume_actual <5) {
          			this.$swal('Alert!', 'Volume Actual value must have at least five(5) ', 'warning')
          			return false
        		}
				return true
			},
			est_detail() {
				this.calculate = true
			},
			inputBlur(variableName) {
				let variableValue = this[variableName]
				if(variableValue.length == 0) {
					this[variableName] = "0.00"
				} 
				else {
					let tempValue = variableValue.split(".")
					if(tempValue.length == 1) {
						this[variableName] = String(variableValue) + ".00"
					} 
					else if(tempValue.length == 2) {
						this[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2)
					}
				}
			},
			waterActualNumber(evt) {
				let dotPosition = this.water_percentage_actual.indexOf(".")
				let hasDot = dotPosition > -1
				let length = this.water_percentage_actual.length
				this.isNumber(evt, hasDot, dotPosition, length)
			},
			volumeActualNumber(evt) {
				let dotPosition = this.volume_actual.indexOf(".")
				let hasDot = dotPosition > -1
				let length = this.volume_actual.length
				this.isNumber(evt, hasDot, dotPosition, length)
			},
			oilActualNumber(evt) {
				let dotPosition = this.oil_actual.indexOf(".")
				let hasDot = dotPosition > -1
				let length = this.oil_actual.length
				this.isNumber(evt, hasDot, dotPosition, length)
			},
			bswNumber(evt) {
				let dotPosition = this.bsw.indexOf(".")
				let hasDot = dotPosition > -1
				let length = this.bsw.length
				this.isNumber(evt, hasDot, dotPosition, length)
			},
			volumeEstimateNumber(evt) {
				let dotPosition = this.volume_estimate.indexOf(".")
				let hasDot = dotPosition > -1
				let length = this.volume_estimate.length
				this.isNumber(evt, hasDot, dotPosition, length)
			},
			temperatureLoad(evt) {
				if (this.cnr && this.cnr_details.length>0) {
					let dotPosition = this.cnr_details[0].temperature_load.indexOf(".")
					let hasDot = dotPosition > -1
					let length = this.cnr_details[0].temperature_load.length
					this.isNumber(evt, hasDot, dotPosition, length)
				}

			},
			temperatureULoad(evt) {
				if (this.cnr && this.cnr_details.length>0) {
					let dotPosition = this.cnr_details[0].temperature_unload.indexOf(".")
					let hasDot = dotPosition > -1
					let length = this.cnr_details[0].temperature_unload.length
					this.isNumber(evt, hasDot, dotPosition, length)
				}
			},
			grossWeight(evt) {
				if (this.cnr && this.cnr_details.length>0) {
					let dotPosition = this.cnr_details[0].gross_weight.indexOf(".")
					let hasDot = dotPosition > -1
					let length = this.cnr_details[0].gross_weight.length
					this.isNumber(evt, hasDot, dotPosition, length)
				}
			},
			tareWeight(evt) {
				if (this.cnr && this.cnr_details.length>0) {
					let dotPosition = this.cnr_details[0].tare_weight.indexOf(".")
					let hasDot = dotPosition > -1
					let length = this.cnr_details[0].tare_weight.length
					this.isNumber(evt, hasDot, dotPosition, length)
				}
			},
			inputBlur1(variableName) {
				if (this.cnr && this.cnr_details.length>0) {
					let variableValue = variableName //this.cnr_details[0].temperature_load
					if(variableValue.length == 0) {
						variableName = "0.00" //this.cnr_details[0].temperature_load = "0.00"
					} else {
						let tempValue = variableValue.split(".")
						if(tempValue.length == 1) {
							variableName = String(variableValue) + ".00"//this.cnr_details[0].temperature_load = String(variableValue) + ".00"
						} else if(tempValue.length == 2) {
							variableName = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2) //this.cnr_details[0].temperature_load = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2)
						}
					}
				}
			},
			isNumber: function(evt, hasDot, dotPosition, length) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
					let selectionStart = evt.target.selectionStart;
					let selectionEnd = evt.target.selectionEnd;
					if((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart ) && length-2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
						evt.preventDefault();
					} else {
						return true
					}
				} else {
					evt.preventDefault();
				}
			},
			selects_energy_company() {
				if (this.role == 'trucking_company_admin' || this.role =='trucking_operational_manager') {
					let trucking_companies = this.trucking_companies
					this.truck_company_select = this.trucking_companies[0]['id']
					this.truck_company_id = this.trucking_companies[0]['id']
					let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.truck_company_id)
					if (current_truck_company_index > -1) {
						let drivers = this.trucking_companies[0]['drivers']
						let drivers_index = drivers.map(o => o.id).indexOf(this.user_id)
						if (drivers_index > -1) {
							let energycompanies =  drivers[drivers_index]['energy_companies']
							let energy_company_index = energycompanies.map(o => o.id).indexOf(this.energy_companies_id)
							this.getLoadLocation (energycompanies[energy_company_index].id, drivers[drivers_index].id)
						}
					}
				}
				if (this.role == 'super_admin') {
					let trucking_companies = this.trucking_companies
					let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.truck_company_id)
					if (current_truck_company_index > -1) {
						let drivers = trucking_companies[current_truck_company_index]['drivers']
						let drivers_index = drivers.map(o => o.id).indexOf(this.user_id)
						if (drivers_index > -1) {
							let energycompanies =  drivers[drivers_index]['energy_companies']
							let energy_company_index = energycompanies.map(o => o.id).indexOf(this.energy_companies_id)
							this.getLoadLocation (energycompanies[energy_company_index].id, drivers[drivers_index].id)
						}
					}
				}
			},
			selects_load_location() {
				let loads_locations = this.loads_locations
				let loads_locations_index = loads_locations.map(o => o.id).indexOf(this.load_location_id)
				if (loads_locations_index > -1) {
					let fluid_types = loads_locations[loads_locations_index]['fluids']
					this.fluid_type_select = fluid_types.map((item) => {
						return {
							'value': item.id,
							'text': item.name
						}
					})
					this.tdg_select = []
					let ft_index = fluid_types.map(o => o.id).indexOf(this.fluid_type_id)
					if (ft_index > -1) {
						if ('tdg' in fluid_types[ft_index]) {
							this.tdg_select = fluid_types[ft_index].tdg
						} 
					}
				}
			},
			toggleInfoWindow: function(marker, idx) {
				this.infoWindowPos = marker.position
				this.infoContent = marker.title
				this.infoLink = marker.www
				// check if its the same marker that was selected if yes toggle
				if (this.currentMidx === idx) {
					this.infoWinOpen = !this.infoWinOpen
				} else {
					// if different marker set infowindow to open and reset current marker index
					this.currentMidx = idx
					this.infoWinOpen = true
				}
			},
			get_folders_by () {
				this.folderOptions =[]
        		haul_service.get_folders_by (this.energy_companies_id)
          		.then((data) => {
                	if (data.status  == 'success') {
						this.folders = data.folders			
						this.folders.map(item => {
							var item_data = {}
							item_data['value'] = item.id
							item_data['text'] = item.name
							this.folderOptions.push(item_data)
						})
					}
					else {
						this.$swal(data.status, data.message, data.status)
						this.folders = []
                	}
          		})
          		.catch(error => {
					this.$swal('Error', 'Server not response. ' + error, 'error')
					this.folders = []
          		})
			},
			addHaulsFolder() {
				if (this.selected.length < this.folderHaulIds.length && this.folderHaulIds.length != 0 ) {
					this.removeHaul()
				}
				else {
					if (this.selected.length != 0) {
						this.addHaul()
					}
					else {
						Vue.swal('warning', 'Please select almos 1 folder', 'warning')
						this.modalFolders = false
						this.getHaulData()
						this.loadingData = true
					}
				}
			},
			addHaul() {
				this.foldersHauls=[]
				this.selected.map(item => {
					var item_data = {}
					item_data['folder_id'] = item
					item_data['haul_id'] = this.haulId
					this.foldersHauls.push(item_data)
				})
				haul_service.addHaulsFolder(this.foldersHauls)
				.then((data) => {
					if (data.status == 'success') {
						Vue.swal(data.status, data.message, data.status)
						this.haul_ids = []
						this.modalFolders = false
						this.getHaulData()
						this.loadingData = true
					}
					else {
						Vue.swal(data.status, data.message, data.status)
						this.modalFolders = false
						this.getHaulData()
						this.loadingData = true
					}
				})
			},
			openModal() {
				this.haul_ids = []
				this.get_folders_by()			
				this.haul_ids.push(this.haulId)
				this.modalFolders = true
			},
			removeHaul() {
				this.removeFolders =[]
				this.folderHaulIds.map((item) => {
					if (!this.selected.includes(item)) {
						this.removeFolders.push(item)
					}
				})
				this.haul_ids = []
				this.haul_ids.push(this.haulId)
				haul_service.remove(this.haul_ids, this.removeFolders)
				.then(data => {
					Vue.swal(data[0], data[1], data[0])
					this.filter = ''
					// this.trash = 2
					this.getHaulData()
					this.loadingData = true
				})
				.catch(error => {
					Vue.swal('Error', 'Server not response. ' + error, 'error')
				})
			},
			hmsToSecondsOnly(str) {
        		var p = str.split(':'),
            	s = 0, m = 1;
        		while (p.length > 0) {
            		s += m * parseInt(p.pop(), 10);
            		m *= 60;
				}
				return s;
			},
			savePersonalTime() {
        		haul_service.savePersonalTime(0,this.filters_save)
          		.then((data) => {
                	if (data[0] == 'success') {
                    	return data[0]
                	} else {
                    	Vue.swal(data[0], data[1], data[0])
                    	return 0
                	}
          		})
          		.catch(error => {
            		Vue.swal('Error', 'Server not response. ' + error, 'error')
            		return 0
          		})
			},
			invoiced_cost_click() {
				console.log('click')
				this.edit_invoiced_cost = true
				this.invoiced_cost_text  = this.invoiced_cost
				this.justification_text  = this.justification
			},
			invoicedcostNumber(evt) {
				let dotPosition = this.invoiced_cost_text.indexOf(".")
				let hasDot = dotPosition > -1
				let length = this.invoiced_cost_text.length
				this.isNumber(evt, hasDot, dotPosition, length)
			},
			invoiced_cost_cancel() {
				this.edit_invoiced_cost = false
			},
			invoiced_cost_update() {
				let invoiced_cost = {'invoiced_cost': this.invoiced_cost_text,'justification': this.justification_text}
				haul_service.invoiced_cost_update(invoiced_cost, this.haulId)
				.then((data) => {
					this.$swal(data[0], data[1], data[0])
					.then((result) => {
						this.invoiced_cost  = this.invoiced_cost_text
						this.justification  = this.justification_text
						this.$root.$emit('haul_Updated')
					})
				})
				.catch(error => {
					this.$swal('Error', 'Server not response. ' + error, 'error')
				})
				this.edit_invoiced_cost = false
			},
			HZChange() {
				if (this.hazard_id.length === 0) {
					this.indeterminateHZ = false
					this.hzAllSelected = false
				} else if (this.hazard_id.length === this.hazards.length) {
					this.indeterminateHZ = false
					this.hzAllSelected = true
				} else {
					this.indeterminateHZ = true
					this.hzAllSelected = false
				}
			},
			HZToggleAll(checked) {
				this.hazard_id = checked ? this.hazards.map(item => {
					return item.id
				}) : []
			},
			CTLChange() {
				if (this.control_id.length === 0) {
					this.indeterminateCTL = false
					this.ctlAllSelected = false
				} else if (this.control_id.length === this.controls.length) {
					this.indeterminateCTL = false
					this.ctlAllSelected = true
				} else {
					this.indeterminateCTL = true
					this.ctlAllSelected = false
				}
			},
			CTLToggleAll(checked) {
				this.control_id = checked ? this.controls.map(item => {
					return item.id
				}) : []
			},
			HZ1Change() {
				if (this.hazard1_id.length === 0) {
					this.indeterminateHZ1 = false
					this.hz1AllSelected = false
				} else if (this.hazard1_id.length === this.hazards.length) {
					this.indeterminateHZ1 = false
					this.hz1AllSelected = true
				} else {
					this.indeterminateHZ1 = true
					this.hz1AllSelected = false
				}
			},
			HZ1ToggleAll(checked) {
				this.hazard1_id = checked ? this.hazards.map(item => {
					return item.id
				}) : []
			},
			CTL1Change() {
				if (this.control1_id.length === 0) {
					this.indeterminateCTL1 = false
					this.ctl1AllSelected = false
				} else if (this.control1_id.length === this.controls.length) {
					this.indeterminateCTL1 = false
					this.ctl1AllSelected = true
				} else {
					this.indeterminateCTL1 = true
					this.ctl1AllSelected = false
				}
			},
			CTL1ToggleAll(checked) {
				this.control1_id = checked ? this.controls.map(item => {
					return item.id
				}) : []
			},
			select_truck_unit() {
				if (this.role == 'trucking_company_admin' || this.role =='trucking_operational_manager') {
					let trucking_companies = this.trucking_companies
					this.truck_company_select = this.trucking_companies[0]['id']
					this.truck_company_id = this.trucking_companies[0]['id']
					let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.truck_company_id)
					if (current_truck_company_index > -1) {
						this.truck_unit_select = this.trucking_companies[0]['truck_units']
					}
				}
				if (this.role == 'super_admin') {
					let trucking_companies = this.trucking_companies
					let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.truck_company_id)
					if (current_truck_company_index > -1) {
						this.truck_unit_select = trucking_companies[current_truck_company_index]['truck_units']
					}
				}
			},
		}
	}
</script>
<style scoped>
	.haul-title {
		color: #3F3F46;
		font-weight: 600;
	}
/deep/	.col-form-label {
		padding-top: calc(0.375rem + 1px);
		padding-bottom: 2px;
		margin-bottom: 0;
		font-size: 11px !important;
		color: #9e9e9e;
		font-weight: bold;
		width: 100%;
	}
/deep/ .form-control-plaintext {
		font-size: 11px !important;
		width: 100%;
	}
/deep/ .custom-select {
	padding-left: 0;
}
	#haul-information{
		scrollbar-color: #c7c7ce #dae9eb !important;
		scrollbar-width: thin !important;
		overflow-y: auto;
		overflow-x: hidden;
		scrollbar-gutter: stable
	}
</style>


// WEBPACK FOOTER //
// src/views/hauls/HaulPopup.vue